import * as go from 'gojs/release/go-module';

import { ProjectResourceType } from 'src/constants/project';
import { Diagram } from 'src/containers/ProjectDiagram/types/diagram';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { createResource } from 'src/containers/ProjectDiagram/utils/resource/createResource';
import {
  ProjectFileUpload,
  ProjectVirtualGraph,
} from 'src/store/state/projects';

export const addProjectResourceToDiagramModel =
  (
    projectResource: ProjectFileUpload | ProjectVirtualGraph,
    type: ProjectResourceType
  ) =>
  (model: Model, diagram: Diagram) => {
    const resourceProps = {
      fields: projectResource.fields,
      value: projectResource.id,
      text: projectResource.name,
    };
    const node =
      type === ProjectResourceType.VIRTUAL_GRAPH
        ? createResource({
            ...resourceProps,
            dataSourceType: (projectResource as ProjectVirtualGraph)
              .dataSourceType,
            type,
          })
        : createResource({
            ...resourceProps,
            type,
          });
    node.pos = diagram.viewportBounds.center.isReal()
      ? go.Point.stringify(diagram.viewportBounds.center)
      : '0 0';

    const existingData = model.nodeDataArray.find(
      (existing) => existing.key === node.key
    );
    if (existingData) {
      console.warn(
        'Resource already exists in addProjectResourceToDiagramModel, refusing to add duplicate',
        { key: node.key }
      );
    } else {
      model.addNodeData(node);
    }
  };
